import { useMutation } from '@tanstack/react-query';
import { postUploadWorkflowContacts } from 'services/api/postUploadWorkflowContacts';

export const useUploadWorkflowContacts = () => {
    const { mutate: uploadWorkflowContacts, isPending } = useMutation({
        mutationFn: postUploadWorkflowContacts,
    });

    return { uploadWorkflowContacts, isPending };
};
